import React, { useEffect, useState } from "react";
import { ArrowUp, ArrowDown, Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

function OrderList({ title, items, onMove, offset, part }) {
  return (
    <div className="card-flat p-4" data-testid={`pose-order-${part}`}>
      <h3 className="font-heading text-base font-medium mb-2">{title}</h3>
      {items.map((it, i) => (
        <div key={it.key} className="flex items-center gap-3 px-2 py-1.5 rounded hover:bg-norea-surfaceHover" data-testid={`pose-order-row-${it.key}`}>
          <span className="w-5 text-xs tabular-nums text-norea-textMuted">{offset + i + 1}</span>
          <span className="flex-1 text-sm">{it.label}</span>
          <button onClick={() => onMove(i, -1)} disabled={i === 0} className="p-1 rounded hover:bg-white disabled:opacity-30" data-testid={`pose-order-up-${it.key}`}><ArrowUp className="w-3.5 h-3.5" /></button>
          <button onClick={() => onMove(i, 1)} disabled={i === items.length - 1} className="p-1 rounded hover:bg-white disabled:opacity-30" data-testid={`pose-order-down-${it.key}`}><ArrowDown className="w-3.5 h-3.5" /></button>
        </div>
      ))}
    </div>
  );
}

export default function DossierPoseOrderPanel() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/dossier-pose/config").then((r) => setCfg(r.data)).catch(() => toast.error("Chargement impossible")); }, []);
  if (!cfg) return <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  const move = (part) => (i, dir) => setCfg((c) => {
    const l = [...c[part]];
    [l[i], l[i + dir]] = [l[i + dir], l[i]];
    return { ...c, [part]: l };
  });
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/dossier-pose/config", { generes: cfg.generes.map((i) => i.key), deposes: cfg.deposes.map((i) => i.key) }); setCfg(r.data); toast.success("Ordre enregistré"); }
    catch { toast.error("Enregistrement impossible"); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-4 max-w-2xl" data-testid="pose-order-panel">
      <p className="text-sm text-norea-textMuted">Ordre des pièces dans le dossier de pose (un seul PDF). Les documents générés viennent toujours avant les documents déposés. Une pièce qui ne concerne pas le dossier (produit, financeur, fourni-posé) est simplement sautée.</p>
      <OrderList title="Partie 1 — documents générés" items={cfg.generes} onMove={move("generes")} offset={0} part="generes" />
      <OrderList title="Partie 2 — documents déposés" items={cfg.deposes} onMove={move("deposes")} offset={cfg.generes.length} part="deposes" />
      <div className="flex justify-end"><button onClick={save} disabled={busy} className="btn-primary text-sm" data-testid="pose-order-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Enregistrer l'ordre</button></div>
    </div>
  );
}
